import { SvgIconProps } from "@mui/material";
import { FC } from "react";

export const Info: FC<SvgIconProps> = ({ width = 20, height = 20, fill = "#009DDE", ...rest }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox={"0 0 20 20"}
            fill={"none"}
            xmlns={"http://www.w3.org/2000/svg"}
            {...rest}
        >
            <g clipPath={"url(#clip0_29_415)"}>
                <path
                    fillRule={"evenodd"}
                    clipRule={"evenodd"}
                    d={
                        "M7.65992 14.1C7.65992 13.8239 7.88378 13.6 8.15992 13.6H11.8999C12.1761 13.6 12.3999 13.8239 12.3999 14.1C12.3999 14.3762 12.1761 14.6 11.8999 14.6H8.15992C7.88378 14.6 7.65992 14.3762 7.65992 14.1Z"
                    }
                    fill={fill}
                />
                <path
                    fillRule={"evenodd"}
                    clipRule={"evenodd"}
                    d={
                        "M8.27992 8.46002C8.27992 8.18388 8.50378 7.96002 8.77992 7.96002H10.0399C10.3161 7.96002 10.5399 8.18388 10.5399 8.46002V13.78C10.5399 14.0562 10.3161 14.28 10.0399 14.28C9.76378 14.28 9.53992 14.0562 9.53992 13.78V8.96002H8.77992C8.50378 8.96002 8.27992 8.73617 8.27992 8.46002Z"
                    }
                    fill={fill}
                />
                <path
                    d={
                        "M9.71992 5.40002C9.57992 5.40002 9.47992 5.50002 9.47992 5.64002C9.47992 5.78002 9.57992 5.88002 9.71992 5.88002C9.85992 5.88002 9.95992 5.76002 9.95992 5.64002C9.95992 5.52002 9.85992 5.40002 9.71992 5.40002Z"
                    }
                    fill={fill}
                />
                <path
                    fillRule={"evenodd"}
                    clipRule={"evenodd"}
                    d={
                        "M8.97992 5.64002C8.97992 5.22388 9.30378 4.90002 9.71992 4.90002C10.1626 4.90002 10.4599 5.27119 10.4599 5.64002C10.4599 6.00886 10.1626 6.38002 9.71992 6.38002C9.30378 6.38002 8.97992 6.05617 8.97992 5.64002ZM9.90098 5.82108C9.95929 5.76276 9.97992 5.69232 9.97992 5.64002C9.97992 5.58773 9.95929 5.51729 9.90098 5.45897C9.84266 5.40066 9.77222 5.38002 9.71992 5.38002C9.64011 5.38002 9.57212 5.41597 9.52892 5.46171C9.48957 5.50337 9.45992 5.56414 9.45992 5.64002C9.45992 5.71591 9.48957 5.77668 9.52892 5.81834C9.57212 5.86408 9.64011 5.90002 9.71992 5.90002C9.77222 5.90002 9.84266 5.87939 9.90098 5.82108Z"
                    }
                    fill={fill}
                />
                <path
                    fillRule={"evenodd"}
                    clipRule={"evenodd"}
                    d={
                        "M9.99992 0.900024C4.97742 0.900024 0.919922 4.97481 0.919922 10C0.919922 15.0252 4.97742 19.1 9.99992 19.1C15.0031 19.1 19.0799 15.0246 19.0799 10C19.0799 9.72388 19.3038 9.50002 19.5799 9.50002C19.8561 9.50002 20.0799 9.72388 20.0799 10C20.0799 15.5755 15.5567 20.1 9.99992 20.1C4.42242 20.1 -0.0800781 15.5748 -0.0800781 10C-0.0800781 4.42524 4.42242 -0.0999756 9.99992 -0.0999756C14.9877 -0.0999756 19.1333 3.52005 19.9331 8.29747C19.9787 8.56983 19.7948 8.82757 19.5225 8.87316C19.2501 8.91875 18.9924 8.73493 18.9468 8.46258C18.2265 4.16 14.4921 0.900024 9.99992 0.900024Z"
                    }
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id={"clip0_29_415"}>
                    <rect width={width} height={height} fill={"white"} />
                </clipPath>
            </defs>
        </svg>
    );
};
